app.controller('SpecialCtrl', ['$scope', '$http', 'Gate', '$translate', function($scope, $http, Gate, $translate){

    $scope.data = {};
    $scope.Gate = Gate;

    $scope.submit = function()
    {
        $scope.sending = true;

        $scope.data.language = window.localStorage.language || window.lng;
        $scope.data.permalink = $scope.Gate.permalink;
        $scope.data.gates = Gate.gates;
        $scope.data.filters = Gate.filter;
        $scope.data.options = Gate.options;
        $scope.data.selected = Gate.selected;

        $http.post('api/notifications/special', $scope.data).
            success(function(data, status, headers, config) {
                $scope.sending = false;

                if(!data.success){
                    alert($translate.instant('UNABLE_TO_SEND_REQUEST'));
                    return;
                }

                alert($translate.instant('REQUEST_SENT_SUCCESSFULLY'));
                $scope.data = {};
            }).
            error(function(data, status, headers, config) {
                $scope.sending = false;
            });
    };

    $scope.$watch('Gate.notes', function(n,o){
        if(n == o) return;
        $scope.data.note = n;
    });

}]);
